import {useState} from 'react'
import PhysicalInventoryForm from './PhysicalInventoryForm';
import PhysicalInventoryList from './PhysicalInventoryList';

const PhysicalInventory = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <PhysicalInventoryForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <PhysicalInventoryList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}  
    </>
  )
}

export default PhysicalInventory